import AuditoriaService from "@/services/AuditoriaService";

export const auditoria = {
  namespaced: true,
  state: {
    auditoria: {},
  },
  actions: {
    getAuditoria({ commit }, payload) {
      return AuditoriaService.GetAuditoria(payload).then(
        (auditoria) => {
          return Promise.resolve(auditoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    postAuditoria({ commit }, payload) {
      return AuditoriaService.PostAuditoria(payload).then(
        (auditoria) => {
          return Promise.resolve(auditoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    putAuditoria({ commit }, payload) {
      return AuditoriaService.PutAuditoria(payload).then(
        (auditoria) => {
          return Promise.resolve(auditoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    deleteAuditoria({ commit }, payload) {
      return AuditoriaService.DeleteAuditoria(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },

    getAuditoriaOData({ commit }, payload) {
      return AuditoriaService.GetAuditoriaOData(payload).then(
        (auditoria) => {
          return Promise.resolve(auditoria);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default auditoria;
